import { APIClient } from "../api_helper";
import * as url from "../url_helper";

const api = new APIClient();

export const deviceAdaptAPI = (id) => {
    return api.get(url.DEVICE_ADAPT(id));
}
export const getLanguageAPI = () => {
    return api.get(url.GET_LANGUAGE());
}
export const deviceAdaptResourceAPI = () => {
    return api.get(url.DEVICE_ADAPT_RESOURCE());
}
export const deviceAdaptSearchResourceAPI = (deviceId, data) => {
    return api.create(url.DEVICE_ADAPT_SEARCH_RESOURCE(deviceId), data);
}

export const deviceAdaptStartAPI = (data) => {
    return api.create(url.DEVICE_ADAPT_START(), data);
}

export const deviceAdaptUpdateAPI = ( data) => {
    return api.create(url.DEVICE_ADAPT_UPDATE(), data);
}

export const deviceAdaptStepAPI = (id, data) => {
    return api.create(url.DEVICE_ADAPT_STEP(id), data);
}

export const deviceAdaptPreviousStepAPI = (id, stepId) => {
    return api.get(url.DEVICE_ADAPT_PREVIOUS_STEP(id, stepId));
}
